{
  "footer": {
    "text": {
      "imprint": "Impression",
      "privacy-policy": "Politique de confidentialité",
      "powered": "Développé par Lumxi GmbH"
    }
  }
}
